import { Class } from '../utils';
import Searcher from './Searcher'; //noinspection JSCommentMatchesSignature,JSCommentMatchesSignature

/**
 *  
 * @class Searches a {Septima.Search.SearchableData}
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.DataSearcher
 * @param {Object} options DataSearcher expects these properties:
 * @param options.searchableData {Septima.Search.SearchableData} An object of type Septima.Search.SearchableData
 */

export default Class(Searcher,
/**  @lends Septima.Search.DataSearcher# */
{
  /**
  * This function is called when a result is selected.
  * @callback Septima.Search.DataSearcher~selectCallback
  * @param {Object} result
  * @param result.title {string}
  * @param result.description {string}
  * @param result.data {object} The selected object
  */
  initialize: function initialize(options) {
    this.searchableData = options.searchableData;
    this.source = this.searchableData.plural.toLowerCase();
    if (options.source) this.source = options.source;
    this.typeId = this.searchableData.singular.toLowerCase();
    if (options.typeId) this.typeId = options.typeId;
    this.type = {
      id: this.typeId,
      singular: this.searchableData.singular,
      plural: this.searchableData.plural
    };
    this.Searcher(options);
    this.registerType(this.source, this.type);
  },
  fetchData: function fetchData(query, caller) {
    var queryResult = this.createQueryResult();
    var hits = this.searchableData.query(query.queryString);
    var count = hits.length;

    if (["list", "cut", "no-cut"].indexOf(query.type) !== -1) {
      var hitsShown = count === 1 ? 1 : query.type === 'no-cut' && count > query.limit ? 0 : Math.min(count, query.limit);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = hits.slice(0, hitsShown)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var hit = _step.value;
          var displayname = hit.title;
          if (!query.hasTarget) displayname += " (" + this.searchableData.singular + ")";
          var description = hit.description;
          var geometry = null;
          if (hit.geometry) geometry = hit.geometry;
          var result = queryResult.addResult(this.source, this.type, displayname, description, geometry, hit.object);
          if (hit.id) result.id = hit.id;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (count > hitsShown && ["no-cut", "cut"].indexOf(query.type) !== -1) queryResult.addNewQuery(this.source, this.type, this.searchableData.plural + " (" + count + ")", null, query.queryString, null, null);
    } else {
      if (count > 0) queryResult.addNewQuery(this.source, this.type, this.searchableData.plural + " (" + count + ")", null, query.queryString, null, null);
    }

    setTimeout(function () {
      caller.fetchSuccess(queryResult);
    }, 100);
  },
  get: function get(id) {
    var _this = this;

    if (this.searchableData.isGettable()) return new Promise(function (resolve, reject) {
      var hit = _this.searchableData.get(id);

      if (hit !== null) {
        var queryResult = _this.createQueryResult();

        var displayname = hit.title;
        var description = hit.description;
        var geometry = null;
        if (hit.geometry) geometry = hit.geometry;
        var result = queryResult.addResult(_this.source, _this.typeId, displayname, description, geometry, hit.object);
        result.id = hit.id;
        resolve(result);
      } else {
        reject(new Error('Whoops! get(id) failed in ' + _this.typeId + ' searcher'));
      }
    });else return Promise.reject(new Error('Whoops! get(id) is not implemented in ' + this.typeId + ' searcher'));
  },
  CLASS_NAME: 'Septima.Search.DataSearcher'
});